import { useQuery } from '@tanstack/react-query';
import { SessionEegData } from '@repo/shared/dtos/my-insights/SessionEegDto';
import { myInsightsQueryKeys } from './queryKeys';
import { ANALYTICS_SESSIONS_BASE_URL, CACHE_DURATION_MS, DEFAULT_SAMPLE_SIZE } from '../config/constants';

async function fetchSessionEeg(sessionId: string, limit: number): Promise<SessionEegData | null> {
  const params = new URLSearchParams({ limit: String(limit) });
  const response = await fetch(`${ANALYTICS_SESSIONS_BASE_URL}/${sessionId}/eeg?${params}`);

  if (!response.ok) {
    if (response.status === 404) return null;
    throw new Error(`Failed to load EEG data: ${response.status}`);
  }

  const text = await response.text();
  if (!text) return null;
  return JSON.parse(text) as SessionEegData;
}

export const useSessionEeg = (sessionId?: string, options?: { limit?: number }) => {
  const limit = options?.limit ?? DEFAULT_SAMPLE_SIZE;
  const { data: eegData = null, isLoading, error } = useQuery({
    queryKey: myInsightsQueryKeys.sessionDetail.eeg(sessionId ?? '', limit),
    queryFn: () => fetchSessionEeg(sessionId!, limit),
    enabled: !!sessionId,
    retry: 1,
    staleTime: CACHE_DURATION_MS,
  });

  return { eegData, isLoading, error: error as Error | null };
};
